/**
 * LandingPage.tsx — D2C Landing Page (goldenchronicle.org)
 * Tenant: goldenchronicle.org
 * Route: /
 *
 * STUB — Hero section placeholder.
 * Replace with full marketing page when ready.
 */
import { useNavigate } from "react-router-dom";

export default function LandingPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-stone-50 px-6 text-center">
      {/* Hero */}
      <h1 className="font-['Playfair_Display'] text-5xl font-bold text-stone-800 leading-tight mb-4">
        Golden Chronicle
      </h1>
      <p className="text-stone-500 text-lg max-w-md mb-8">
        Beautifully crafted memorial tribute videos — honoring a life well lived.
      </p>
      <button
        onClick={() => navigate("/intake")}
        className="px-8 py-4 rounded-xl bg-stone-800 text-white font-semibold text-base hover:bg-stone-700 active:scale-[0.98] transition-all duration-150 shadow"
      >
        Begin Your Tribute
      </button>
      <p className="mt-4 text-xs text-stone-400">
        {/* PLACEHOLDER — full landing page coming soon */}
        Landing page under construction.
      </p>
    </div>
  );
}
